import { AccountPlanName } from '@adjust/dashboard-core/api/types';
import { Plan } from '@api/types';
import { ChangeType } from './interfaces';

export const isPlan = (planName: AccountPlanName, plan?: Plan) => Boolean(plan?.name === planName);

export const isBasicPlan = (plan?: Plan) => isPlan(AccountPlanName.Basic, plan);

export const isBusinessPlan = (plan?: Plan) => isPlan(AccountPlanName.Business, plan);

export const isFlatPlan = (plan?: Plan) => isPlan(AccountPlanName.Flat, plan);

export const shouldShowAttributions = (plan: Plan) => Boolean(isBasicPlan(plan) || isBusinessPlan(plan));

export const allowUpgradePlan = (plan: Plan, currentPlan?: Plan) =>
  isBasicPlan(currentPlan) && isBusinessPlan(plan) && plan.yearly === currentPlan?.yearly;

export const allowDowngradePlan = (plan: Plan, currentPlan?: Plan) =>
  isBusinessPlan(currentPlan) && isBasicPlan(plan) && !plan.yearly && !currentPlan?.yearly;

export const allowChangePlan = (plan: Plan, currentPlan?: Plan) =>
  !plan.scheduled && (allowDowngradePlan(plan, currentPlan) || allowUpgradePlan(plan, currentPlan));

export const allowChoosePlan = (plan: Plan, currentPlan?: Plan) =>
  !currentPlan && (isBasicPlan(plan) || isBusinessPlan(plan));

export const isCompatibleWithYearly = (plan: Plan, currentPlan?: Plan) =>
  plan.yearly && currentPlan && plan.name === currentPlan.name && !currentPlan.yearly;

export const getChangeType = (plan: Plan, currentPlan?: Plan): ChangeType => {
  if (currentPlan && !currentPlan.yearly && plan.yearly) {
    return ChangeType.Yearly;
  }

  if (!currentPlan) {
    return ChangeType.Choose;
  }

  if (allowUpgradePlan(plan, currentPlan)) {
    return ChangeType.Upgrade;
  } else {
    return ChangeType.Downgrade;
  }
};
